import type { FetchFunction } from '#layers/base/public';

interface UpdateRolePoliciesOptions {
	fetch: FetchFunction;
	policyIds: string[];
	roleId: string;
}

export async function connectRolePolicies({ fetch, policyIds, roleId }: UpdateRolePoliciesOptions): Promise<void> {
	if (policyIds.length === 0) return;

	await Promise.all(
		policyIds.map((policyId) =>
			fetch(`roles/${roleId}/policies`, {
				method: 'POST',
				body: { policyId },
			}),
		),
	);
}

export async function disconnectRolePolicies({ fetch, policyIds, roleId }: UpdateRolePoliciesOptions): Promise<void> {
	if (policyIds.length === 0) return;

	await Promise.all(
		policyIds.map((policyId) =>
			fetch(`roles/${roleId}/policies`, {
				method: 'DELETE',
				body: { policyId },
			}),
		),
	);
}
